
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cHhL0", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $8tdj3 = parcelRequire("8tdj3");


var $lAFHW = parcelRequire("lAFHW");


var $9x2sR = parcelRequire("9x2sR");


var $inPa6 = parcelRequire("inPa6");


var $dD7ks = parcelRequire("dD7ks");

const $9215c0ee1cb39d63$var$i18n = (0, $h82at.defineMessages)({
    TeamsAppShortcutName: {
        id: "side-navigation.custom.teams-app-shortcut.name",
        defaultMessage: "Teams"
    }
});
const $9215c0ee1cb39d63$var$elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $9215c0ee1cb39d63$var$elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
    label: "",
    spacing: "spacious",
    size: "small"
});
function $9215c0ee1cb39d63$export$664dbb7fadd10b41() {
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            type: "LANDING"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { href: href } = (0, $dD7ks.useNavigateToTeamsApp)(t0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "teamsAppShortcut",
                    source: "globalNavigation"
                }
            }).fire();
        };
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const fireClickAnalyticsEvent = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $9215c0ee1cb39d63$var$i18n.TeamsAppShortcutName);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== fireClickAnalyticsEvent || $[5] !== href) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            elemAfter: $9215c0ee1cb39d63$var$elemAfter,
            elemBefore: $9215c0ee1cb39d63$var$elemBefore,
            href: href,
            target: "_blank",
            onClick: fireClickAnalyticsEvent
        }, t2);
        $[4] = fireClickAnalyticsEvent;
        $[5] = href;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
}
module.exports["TeamsAppShortcutItem"] = $9215c0ee1cb39d63$export$664dbb7fadd10b41;

});


//# sourceMappingURL=TeamsAppShortcutItem.e6da9797.js.map
